module.exports = __webpack_public_path__ + "static/img/6.cfceeb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/6.png
// module id = 4Bap
// module chunks = 0